import { Injectable, EventEmitter, inject, Injector } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigurationManagerService } from './configuration-manager.service';
import { catchError, map } from 'rxjs/operators';
import { ArcAngelModesService } from './arc-angel-modes.service';
import { SessionOption } from './facility-pin.service';
import { OrganizationUtilService } from './organization-util.service';

export class EventOption {
  constructor(public incidentId: string, public type: string) {}
}

@Injectable({
  providedIn: 'root'
})
export class SessionOptionsService {
  private modeSubject = new BehaviorSubject<string>('Monitor Mode');
  private sessionData: any = {};
  apiKey: string = ConfigurationManagerService.settings.BaseURL;

  // Public observable for mode changes
  public mode$: Observable<string> = this.modeSubject.asObservable();
  sessionOptionsReset = new EventEmitter<void>();
  private injector: Injector;
  private arcAngelModeService?: ArcAngelModesService;
  private _arcliveActions: string[] | null = null;
  public dataCache: any = {};
  public facilities: any[] = [];
  public users: any[] = [];
  public organizations: any[] = [];
  public cameras: any[] = [];
  public geofences: any[] = [];
  public phoneNumbers: any[] = [];
  public _orgTreeItemList: any[] = [];
  public _orgTree: any = {};
  orgTreeList: any[] = [];
  entity: {} | undefined;
  notificationsList: any[] = [];
  incidentDetails: any[] = [];
  perimterInfo: any[] = [];

  ArcliveActions = {
    arclive: 'arclive',
    arclive_integration_genetec: 'arclive.integration.genetec',
    arclive_integration_socialMedia: 'arclive.integration.socialMedia',
    arclive_feature_showHomeLocations: 'arclive.feature.showHomeLocations',
    arclive_communication_sms: 'arclive.communication.sms',
    arclive_communication_notification: 'arclive.communication.notification',
    arclive_communication_email: 'arclive.communication.email',
    arclive_communication_voice: 'arclive.communication.voice',
  };

  constructor(
    private http: HttpClient,
    private orgUtil: OrganizationUtilService,
    injector: Injector
  ) {
    this.injector = injector;
  }

  private getArcAngelModeService(): ArcAngelModesService {
    if (!this.arcAngelModeService) {
      this.arcAngelModeService = this.injector.get(ArcAngelModesService);
    }
    return this.arcAngelModeService;
  }

  clearAllSessionData(): void {
    this.facilities = [];
    this.users = [];
    this.organizations = [];
    this.cameras = [];
    this.geofences = [];
    this.phoneNumbers = [];
    this._orgTreeItemList = [];
    this.entity = {};
    this.notificationsList = [];
    this.incidentDetails = [];
    this.perimterInfo = [];
    this.dataCache = {};
    this._orgTree = {};
    this.orgTreeList = [];
  }
  SessionOption(mode: string, eventOption: any, byPassPin?: boolean, suppressReset?: boolean) {
    const LIVE_MODE = 'Live Mode';
    const obj: any = {
      mode,
      suppressReset: !!suppressReset,
      isPinNeeded: false
    };
    if (eventOption) {
      if (typeof eventOption.getEventId === 'function') {
        obj.eventId = eventOption.getEventId();
      } else if (eventOption.incidentId) {
        obj.eventId = eventOption.incidentId;
      }
      if (typeof eventOption.getEventType === 'function') {
        obj.eventType = eventOption.getEventType();
      } else if (eventOption.type) {
        obj.eventType = eventOption.type;
      }
      obj.eventOption = eventOption;
    }
    if (mode === LIVE_MODE && !byPassPin) {
      obj.isPinNeeded = true;
    }
    return obj;
  }
  setMode(mode: string): void {
    this.modeSubject.next(mode);
  }

  getMode(): string {
    return this.modeSubject.value;
  }

  setSessionData(data: any): void {
    if (!(data instanceof SessionOption)) {
      this.sessionData = new SessionOption(data.mode, data.eventOption, data.byPassPin, data.suppressReset);
    } else {
      this.sessionData = data;
    }
  }

  getSessionData(): any {
    return this.sessionData;
  }

  isPlaybackMode(): boolean {
    return this.getMode() === 'Playback Mode';
  }

  isLiveMode(): boolean {
    return this.getMode() === 'Live Mode';
  }

  isMonitorMode(): boolean {
    return this.getMode() === 'Monitor Mode'; 
  }

  getOrgTree(): Observable<{ groups: any[]; count: number }> {
    const url = `${this.apiKey}db/Group/findAndCountAll`;
    const body = { limit: 10000 };
    return this.http.post<{ rows: any[]; count: number }>(url, body).pipe(
      map(res => ({
        groups: res.rows,
        count: res.count
      }))
    );
  }

  getArcliveActions(): Observable<string[]> {
    if (this._arcliveActions) {
      return of(this._arcliveActions);
    }

    const params = {
      attributes: ['code', 'id'],
      where: {
        $or: [
          { code: { $like: 'arclive%' } },
          { code: { $like: 'analytics' } }
        ]
      }
    };

    return this.http.post<any>(`${this.apiKey}db/Action/sessionWithOrganizationIds`, params).pipe(
      map(response => {
        const features = response.rows.map((action: any) => action.code);
        const myOrgs = this.orgUtil.myOrgs || {};
        if (features.length && Object.keys(myOrgs).length > 0) {
          this._arcliveActions = features;
        }
        return features || [];
      }),
      catchError((error: any) => {
        console.error('Error getting arclive actions:', error);
        return of([]);
      })
    );
  }

  getAllHomeLocations(): Observable<any> {
    const params = {
        attributes: ['userId', 'position', 'country', 'region', 'place'],
        limit: 10000
    };
    return this.http.post<any>(`${this.apiKey}db/UserAddress/findAndCountAllFromOrganization`, params);
  }

  goToLiveIncidentMode(incidentId: string, byPassPin?: boolean, suppressReset?: boolean): void {
    const LIVE_MODE = 'Live Mode';
    const INCIDENT = 'INCIDENT';
    const newEvent = new EventOption(incidentId, INCIDENT);
    this.setSessionData(this.SessionOption(LIVE_MODE, newEvent, byPassPin, suppressReset));
    this.setMode(LIVE_MODE);
    // this.sessionOptionsReset.emit();
  }
 goToMonitorMode(): void {
  this.getArcAngelModeService().resetArcAngelService('Monitor Mode', '', '', false, null, true);
  this.setMode('Monitor Mode');
	}
  goToLiveProcallMode(id: string, byPassPin?: boolean): void {
    const LIVE_MODE = 'Live Mode';
    const PROCALL = 'PROCALL';
    const newEvent = new EventOption(id, PROCALL);
    this.setSessionData(this.SessionOption(LIVE_MODE, newEvent, byPassPin));
    this.setMode(LIVE_MODE);
    this.sessionOptionsReset.emit();
  }
  goToLiveTrackingMode(id: string, byPassPin?: boolean): void {
    const LIVE_MODE = 'Live Mode';
    const TRACKING = 'TRACKING';
    const newEvent = new EventOption(id, TRACKING);
    this.setSessionData(this.SessionOption(LIVE_MODE, newEvent, byPassPin));
    this.setMode(LIVE_MODE);
    this.sessionOptionsReset.emit();
  }
}